// removed by extract-text-webpack-plugin
module.exports = {"IntegrationControl":"IntegrationControl---VkqRe","IntegrationLink":"IntegrationLink---2N7Jj","DisconnectLink":"DisconnectLink---2l2Hk"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/Integration/components/style.styl
// module id = ndOC
// module chunks = 89